<div
  class="munily-image-preview-ia"
  [ngClass]="hostClasses"
>
  <div class="munily-image-preview-ia__frame">
    <ng-container *ngIf="hasImage; else iconOrEmpty">
      <img class="munily-image-preview-ia__img" [src]="safeImageSrc" [alt]="alt" />
    </ng-container>
    <ng-template #iconOrEmpty>
      <div class="munily-image-preview-ia__empty">
        <mat-icon
          *ngIf="hasIcon; else emptyState"
          [ngClass]="iconSet"
          aria-hidden="true"
        >{{ icon }}</mat-icon>
        <ng-template #emptyState>
          <mat-icon class="material-symbols-rounded" aria-hidden="true">image</mat-icon>
        </ng-template>
      </div>
    </ng-template>

    <mat-icon
      *ngIf="effectiveSelected"
      class="munily-image-preview-ia__check material-symbols-rounded"
      aria-hidden="true"
    >
      check_circle
    </mat-icon>

    <div class="munily-image-preview-ia__action" *ngIf="showAction">
      <common-icon-button
        variant="plain"
        [icon]="actionIcon"
        [ariaLabel]="actionAriaLabel"
        color="weak"
        type="filled"
        size="small"
        iconSet="material-icons-outlined"
        [disabled]="disabled"
        [stopClickPropagation]="true"
        [menuTriggerFor]="menu"
        (output)="onAction()"
      ></common-icon-button>
    </div>

    <!-- Keep mat-menu outside *ngIf so #menu is defined when passed to icon-button (OnPush). -->
    <mat-menu #menu="matMenu">
      <button *ngIf="showReplaceOption" mat-menu-item type="button" (click)="onMenuAction('replace')">
        {{ 'commonComponents.imagePreviewIconAction.menu.replace' | translate }}
      </button>
      <button *ngIf="showSetCoverOption && !effectiveSelected" mat-menu-item type="button" (click)="onMenuAction('setCover')">
        {{ 'commonComponents.imagePreviewIconAction.menu.setCover' | translate }}
      </button>
      <button *ngIf="showDeleteOption" mat-menu-item type="button" (click)="onMenuAction('delete')">
        {{ 'commonComponents.imagePreviewIconAction.menu.delete' | translate }}
      </button>
    </mat-menu>
  </div>
</div>
